module.exports = __webpack_public_path__ + "img/202412240101.81fcf92d.jpeg";